import { render, staticRenderFns } from "./DivisorComLegenda.vue?vue&type=template&id=064fba82&scoped=true"
import script from "./DivisorComLegenda.vue?vue&type=script&lang=js"
export * from "./DivisorComLegenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064fba82",
  null
  
)

export default component.exports